import { ConsentDetails } from 'usercentrics';
import { isLocalhost } from './helper';

export const setupUsercentrics = async () => {
  (await window.__ucCmp?.isInitialized())
    ? handleUsercentricsConsent()
    : window.addEventListener('UC_UI_INITIALIZED', () => handleUsercentricsConsent());
};

export const handleUsercentricsConsent = async (consentDetails?: ConsentDetails) => {
  location.reload();
};

export const showUsercentricsSecondLayer = () => {
  window.__ucCmp?.showSecondLayer();
};

export const isServiceConsented = async (serviceName: string, consentDetails?: ConsentDetails) => {
  const uc = window?.__ucCmp;
  if (!uc) {
    return undefined;
  }
  consentDetails ??= await uc.getConsentDetails();
  const services = Object.values(consentDetails.services);
  const service = services.find((service) => service.name === serviceName);
  if (!service) return undefined;
  if (!service.consent) return undefined;
  return service.consent.given;
};

export const isUsercentricsEnabled = () =>
  isLocalhost() || (window.__ucCmp && Object.keys(window.__ucCmp).length > 0);
